<script setup>
import SupplierHeader from '@supplier/layouts/components/SupplierHeader.vue'
import SupplierImpersonationBanner from '@supplier/layouts/components/SupplierImpersonationBanner.vue'
</script>

<template>
  <div class="supplier-layout">
    <supplier-impersonation-banner />
    <supplier-header />
    <main class="supplier-layout-main">
      <div class="page-container">
        <slot />
      </div>
    </main>
  </div>
</template>

<style lang="scss" scoped>
.supplier-layout {
  --supplier-header-height: 64px;

  display: flex;
  flex-direction: column;
  min-height: 100vh;

  &-main {
    flex: 1;
    padding: 24px 0 48px;
  }
}
</style>
